import { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Paper } from '@mui/material'
import { MotionDivContainer } from '@components'
import { Toolbar } from './toolbar'

const PaperContainer = styled(Paper)`
  height: 100%;
  overflow: hidden;
`

const Main = styled.div`
  height: calc(100% - 111px);
`

export const Layout = ({ children }: { children: ReactElement | ReactElement[] }) => (
  <MotionDivContainer>
    <PaperContainer elevation={3}>
      <Main>
        <Toolbar />
        {children}
      </Main>
    </PaperContainer>
  </MotionDivContainer>
)
